import type { Bereichskennung } from '@crm/kontrakte';

import { rufe } from './client';

/**
 * Die Benachrichtigungen des Systems (ERR-10; Auftrag CRM-207).
 *
 * Was hier steht, gilt einer der eigenen Rollen oder dem Benutzer selbst. Der
 * Server entscheidet das; die Maske zeigt, was kommt.
 */
export type Benachrichtigung = {
  readonly id: string;
  readonly anlass: 'fehlerablage' | 'frist' | 'freigabe' | 'absage';
  /** Wohin der Sprung führt. */
  readonly bereich: Bereichskennung;
  readonly bezug: string | null;
  readonly text: string;
  readonly rolle: string | null;
  /** An mich persönlich und nicht über eine Rolle. */
  readonly persoenlich: boolean;
  /** UTC nach ISO 8601; die Anzeige rechnet in Ortszeit um (LOG-03). */
  readonly entstandenAm: string;
  readonly gelesenAm: string | null;
};

/** Die unerledigten Nachrichten an meine Rollen und an mich. */
export async function meine(): Promise<{ readonly nachrichten: readonly Benachrichtigung[] }> {
  return rufe('/benachrichtigungen/meine');
}

/** Gelesen: gesehen, die Sache steht weiter an. */
export async function gelesen(id: string): Promise<void> {
  await rufe(`/benachrichtigungen/${encodeURIComponent(id)}/gelesen`, { verfahren: 'POST' });
}

/** Erledigt: Sie fällt aus „Das steht an". */
export async function erledigt(id: string): Promise<void> {
  await rufe(`/benachrichtigungen/${encodeURIComponent(id)}/erledigt`, { verfahren: 'POST' });
}
